  window.addEventListener("load", function () {
    let popupShown = false;
    let cartHasItems = false;
    const path = window.location.pathname;
    const isCartOrProductPage = path === '/cart' || path.startsWith('/collections/');

    const popup = document.getElementById("exitPopup");
    const form = popup?.querySelector("form");

    if (!isCartOrProductPage || !popup) return;

    // 1. Check if cart has items
    fetch('/cart.js')
      .then(res => res.json())
      .then(data => {
        if (data.item_count > 0) {
          cartHasItems = true;
        }
      });

    // 2. Show popup on mouse leave (exit intent)
    document.addEventListener("mouseleave", function (e) {
      if (e.clientY <= 0 && !popupShown && cartHasItems && popup) {
        showPopup();
      }
    });

    // 3. Show popup on hover over any header/footer element
    const hoverTargets = document.querySelectorAll("header, footer");
    hoverTargets.forEach(link => {
      link.addEventListener("mouseenter", function () {
        if (!popupShown && cartHasItems && popup) {
          showPopup();
        }
      });
    });

    // 4. Close popup on overlay or close (X) button
    document.addEventListener("click", function (e) {
      if (!popup) return;
      if (
        e.target.classList.contains("close-popup") ||
        e.target.classList.contains("popup-overlay")
      ) {
        popup.style.display = "none";
      }
    });

    // 5. Close popup on form submit (and thank the user)
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        alert("Thank you! Your form is submitted.");
        popup.style.display = "none";
        form.reset();
      });
    }

    // ✅ Show popup helper
    function showPopup() {
      popup.style.display = "flex";
      popupShown = true;
    }
  });